import { orderContainer } from './FootnoteItem.css';
import type { TPostFootnoteItemProps } from './FootnoteItem.types';

export const PostFootnoteItem = ({ element, children }: TPostFootnoteItemProps) => {
  const { attrs } = element;

  return (
    <p id={attrs.footnoteId}>
      <span
        className={orderContainer}
        style={{
          color: 'var(--post-section-text-color)',
        }}
        contentEditable={false}
        suppressContentEditableWarning
      >
        {attrs.order}
      </span>
      <span contentEditable={false} suppressContentEditableWarning>
        &nbsp;&nbsp;
      </span>
      {children}
    </p>
  );
};
